module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-step-buttons"
  }, [_c('div', {
    staticClass: "c-step-buttons--loader"
  }, [_c('div', {
    class: [_vm.running ? 'a-loader a-loader--step-button' : '']
  })]), _vm._v(" "), _c('div', {
    staticClass: "step-button flex-state-buttons"
  }, [_c('button', {
    staticClass: "a-button",
    class: !_vm.prevValid ? 'disabled' : '',
    attrs: {
      "disabled": !_vm.prevValid
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("\n            Back\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    class: [!_vm.nextValid || _vm.running ? 'disabled' : ''],
    attrs: {
      "disabled": !_vm.nextValid || _vm.running
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("\n            Next\n        ")])]), _vm._v(" "), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79cd83e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepButton.vue
// module id = 1753
// module chunks = 0